var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-sprite"},[_c('use',{staticClass:"svg-sprite__sprite",class:_vm.className,attrs:{"xlink:href":_vm.spriteId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }